import { useState, useEffect } from 'react';
import { CustomerListTable } from 'components/tables/HVACampaignCustomerListTable';
import {
  fetchCustomersByCampaign,
  CustomerList
} from 'services/hvaservicecampaign.service';
import HVASpinner from 'components/base/HVASpinner';

interface CampaignCustomerListProps {
  campaignId: number;
}

const CampaignCustomerList = ({ campaignId }: CampaignCustomerListProps) => {
  const [customers, setCustomers] = useState<CustomerList[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadCustomers = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const customersData = await fetchCustomersByCampaign(campaignId);
      setCustomers(customersData);
    } catch (error) {
      setError('Error al cargar los clientes de la campaña');
      console.error('Error:', error);
      setCustomers([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadCustomers();
  }, [campaignId]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5 pb-7">
        <HVASpinner />
      </div>
    );
  }

  if (error) return <div className="text-danger">{error}</div>;

  return (
    <div className="mt-2 bg-body-emphasis">
      <CustomerListTable
        customers={customers}
        onCustomersChange={loadCustomers}
        campaignId={campaignId}
      />
    </div>
  );
};

export default CampaignCustomerList;
